export const ordinary = 49;
// theme's h6 variant (used by both the title and subTitle lines in Header) has
// an explicit lineHeight: '24px' and no default margin, so one extra subTitle
// line adds ~24px. Estimated from the theme, not live-measured like the other
// constants here (their fractional values suggest they were) — nudge if it's
// off by a few px once you can see it rendered.
export const ordinaryWithSubtitle = 73;
export const withSearch = 110.25;
export const withSearchWithSubtitle = 134.25;
export const bottomButton = 76.5;
export const bottomWithTopButton = 127.6;
